import React from 'react';
import { IColumn } from '@fluentui/react';
import { Button } from '@fluentui/react-components';
import { StatUser } from '../../utils/statApi/UsersApi';
import ShimmeredDetailsListWrapper from '../common/DetailsLists/ShimmeredDetailsListWrapper';
import IItemListProps from '../../utils/types/IItemListProps';
import columns from './UsersListConfig';
import { rowCellLinkActionButton } from '../../app/common/styles/CommonStyleObjects';

const UsersList = (props: IItemListProps<StatUser>): JSX.Element => {
  const { items, isLoading, onRowClick } = props;

  const renderItemColumn = (item: StatUser, index: number, column: IColumn): JSX.Element => {
    const fieldContent = item[column.fieldName] as string;

    switch (column.key) {
      case 'name': {
        return (
          <Button
            appearance="transparent"
            style={{ ...(rowCellLinkActionButton.root as React.CSSProperties) }}
            onClick={() => {
              onRowClick(item);
            }}
          >
            {fieldContent}
          </Button>
        );
      }
      case 'role': {
        return <span>{item.roleName}</span>;
      }
      case 'status': {
        const status = item.isActive ? 'Active' : 'Deactivated';
        return <span>{status}</span>;
      }
      default:
        return <span>{fieldContent}</span>;
    }
  };

  return (
    <ShimmeredDetailsListWrapper
      columns={columns}
      items={items || []}
      enableShimmer={isLoading}
      onRenderItemColumn={renderItemColumn}
      singularListLabel="User"
      pluralListLabel="Users"
    />
  );
};
export default UsersList;
